/* eslint-disable prefer-const */
import React, { Component } from 'react';
import noImage from '../../images/no-image-small.png';
import URLSanitizer from '../../services/url-sanitizer';
import { priceFormat, getPhone } from '../../helper';

import styles from './styles/line-item.scss';

class LineItem extends Component {
    buildPhones = (data, types) => {
        if (types) {
            const phoneType = types.find(({ attributes }) => attributes.field_type === 'phone');
            const phoneData = data.filter(({ attributes }) => attributes.type_id === Number(phoneType.id));

            return phoneData.map(
                ({ id, attributes }) => (
                    <div key={attributes.value}>
                        <span>{getPhone(attributes.value)}</span>
                    </div>
                ),
            );
        }

        return null;
    }

    render() {
        // eslint-disable-next-line object-curly-newline
        let {
            lineItem,
            customContent = false,
            col1 = false,
            col2 = false,
            col3 = false,
            noBottomBorder = false,
        } = this.props;
        if (!customContent) {
            const image = lineItem.variant.images[0];
            const imageUrl = image && image.attributes && image.attributes.styles.length > 0
                ? URLSanitizer.makeAbsolute(image.attributes.styles[0].url)
                : noImage;
            col1 = <img className="shipment-line-item-image" alt={lineItem.attributes.name} src={imageUrl} />;
            col2 = (
                <div className={styles.lineItemNameDetailContainer}>
                    <span className={styles.lineItemName}>
                        <strong>{lineItem.attributes.name}</strong>
                        <p>{`${lineItem.variant.attributes.display_price} x ${lineItem.attributes.quantity}`}</p>
                    </span>
                    <div className={styles.lineItemPhones}>
                        {this.buildPhones(lineItem.data_extras, lineItem.data_extra_types)}
                    </div>
                </div>
            );
            col3 = <span>{`${priceFormat.format(lineItem.variant.attributes.price * lineItem.attributes.quantity)}`}</span>;
        }
        return (
            <div className={`row shipment-line-item checkout-line-item-row order-items-row ${noBottomBorder ? 'no-bottom-border' : ''}`}>
                <div className="col-sm-2 col-xs-3 checkout-line-item-image-block order-items-image-block">{col1}</div>
                <div className="col-sm-8 col-xs-6 order-items-content-block">{col2}</div>
                <div className="col-sm-2 col-xs-3 order-items-content-block">{col3}</div>
            </div>
        );
    }
}

export default LineItem;



/** WEBPACK FOOTER **
 ** ./src/components/order/line-item.jsx
 **/